import * as $ from "jquery";

export function activateFooter() {
    const toTopEl = document.getElementById('to-top');
    if (toTopEl) {
        window.addEventListener('scroll', function () {
            showToTopLink(toTopEl);
        });
        triggerToTopLink(toTopEl);
    }

    /**
     * to-top link integration
     *
     * @param {HTMLElement} toTopEl
     */
    function showToTopLink(toTopEl) {
        if ($(document).scrollTop() > 0) {
            toTopEl.classList.add('active');
        } else {
            toTopEl.classList.remove('active');
        }

    }

    function triggerToTopLink(toTopEl) {
        const $toTopLink = $(toTopEl);
        $toTopLink.on('click', function () {
            $('html, body').stop().animate({scrollTop: 0}, 'slow', 'swing');
        })
    }
    
    
    
    
    function isInViewport(element) {
      var elementTop = $(element).offset().top;
      var elementBottom = elementTop + $(element).outerHeight();
    
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
    
      return elementBottom > viewportTop && elementTop < viewportBottom;
    }
    
    $(window).on('load', function() {
        if (isInViewport('#footer')) {
            setTimeout(function() {
                $('.sticky-socials').addClass('is-hidden');
            }, 222);
        }
        else {
            setTimeout(function() {
                $('.sticky-socials').removeClass('is-hidden');
            }, 222);
        }
    });
    
    $(window).on('scroll resize', function () {
        if (isInViewport('#footer')) {
            setTimeout(function() {
                $('.sticky-socials').addClass('is-hidden');
            }, 111);
        }
        else {
            setTimeout(function() {
                $('.sticky-socials').removeClass('is-hidden');
            }, 111);
        }
    });

    

}

